import { SxGeneral } from "../../../../../../../../utils/types/generals"

type SxStyles = SxGeneral<'detail' | 'seeButons' | 'allButons' | 'add' | 'alignHorizontal' | 'wFull' | 'container' | 'header' | 'footer' | 'pagination' | 'list'>
export const useStyles = (): SxStyles => {
    return {
        detail: {
            padding: 2
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
            padding: '2px',
            width: '100%',
        },
        add: {
            fontSize: '2rem',
            color: 'secondary.100'
        },
        alignHorizontal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
        },
        footer: {
            display: 'flex',
            justifyContent: 'end',
            width: '100%'
        },
        pagination: {
            '& .MuiPaginationItem-root': {
                margin: '10px 0 0 0',
            },
        },
        wFull: {
            width: '100%'
        },
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width:'100%',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            maxHeight: '650px',
            width:'100%',
            overflow: 'scroll',
            scrollbarWidth: 'none', // Firefox
            msOverflowStyle: 'none', // Internet Explorer y Edge
            '&::-webkit-scrollbar': {
                display: 'none', // Chrome, Safari y WebKit
            },
            padding: '2px'
        },
        allButons: {
            display: 'flex',
            gap:'3px',
            alignItems: 'center'
        },
        seeButons: {
            textDecoration: 'underline'
        }
    }
}